<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <!-- <template slot="headAction">
        <a-button style="margin-left:10px" type="primary" @click="updatePassWord">重置密码</a-button>
      </template>-->
    </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
// import { cache } from "@/utils/common";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "centralOrder_channel",
  components: { DataTable },
  props: {},
  data() {
    return {
      visible: {
        formModal: false
      }
    };
  },
  created() {
    // const user = cache.get("user");
    this.option = {
      form: {
        colnum: 1,
        width: 600,
        title: "渠道",
        add: {
          submitApi: "GroupChannel_Add",
          onOpenAfter: () => {
            this.setFieldsDisabled(false);
            return { ValidStatus: 1, Sort: 0 };
          }
        },
        edit: {
          infoApi: "GroupChannel_Info",
          submitApi: "GroupChannel_Edit",
          onOpenBefore: () => {
            this.setFieldsDisabled(true);
          }
        },
        del: { submitApi: "GroupChannel_Delete" },
        content: [
          {
            label: "编码",
            name: "Code",
            option: {
              rules: [
                { required: true, message: "请填写编码！" },
                {
                  validator: (rule, value, callback) => {
                    if (value.length > 16) {
                      callback(new Error("不能超过16个字符!"));
                    } else {
                      callback();
                    }
                  }
                }
              ]
            }
          },

          {
            label: "名称",
            name: "Name",
            option: {
              rules: [
                { required: true, message: "请填写名称！" },
                {
                  validator: (rule, value, callback) => {
                    if (value.length > 32) {
                      callback(new Error("不能超过32个字符!"));
                    } else {
                      callback();
                    }
                  }
                }
              ]
            }
          },
          {
            label: "排序",
            name: "Sort",
            type: "number"
          },
          // {
          //   label: "价格代码",
          //   name: "PriceCodeId",
          //   placeholder: "请选择",
          //   option: {
          //     rules: [{ required: true, message: "请选择价格代码！" }]
          //   },
          //   type: "select",
          //   api: "GetGroupSelectItems",
          //   param: { types: "pricecode", CompanyId: user.CompanyId },
          //   dataField: "Data.pricecode"
          // },
          {
            label: "状态",
            name: "ValidStatus",
            placeholder: "请选择",
            option: {
              rules: [{ required: true, message: "请选择状态！" }]
            },
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: 0,
                text: "禁用"
              },
              {
                value: 1,
                text: "启用"
              }
            ]
          },
          {
            label: "AppKey",
            name: "AppKey"
            // option: {
            //   rules: [{ required: true, message: "请填写编码！" }]
            // }
          }
        ]
      },
      grid: {
        api: "GroupChannel_List",
        columns: [
          {
            title: "序号",
            width: "50px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "编码",
            dataIndex: "Code",
            width: 150
          },
          {
            title: "名称",
            dataIndex: "Name",
            width: 200
          },
          {
            title: "排序",
            dataIndex: "Sort",
            width: 100
          },
          {
            title: "AppKey",
            dataIndex: "AppKey"
          },
          {
            title: "状态",
            dataIndex: "ValidStatus",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="禁用" />;
              }
            },
            width: 150
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: 180,
            key: "action",
            customRender: (text, record) => {
              const edit = {
                click: () => {
                  this.edit(record.Id);
                }
              };
              if (record.ChannelAttribute) {
                return (
                  <div>
                    <a-button type="link" {...{ on: edit }}>
                      编辑
                    </a-button>{" "}
                    | <a-button type="link">属性设置</a-button>
                  </div>
                );
              } else {
                const del = {
                  click: () => {
                    this.del(record.Id);
                  }
                };
                return (
                  <div>
                    <a-button type="link" {...{ on: edit }}>
                      编辑
                    </a-button>{" "}
                    |{" "}
                    <a-button type="link" {...{ on: del }}>
                      删除
                    </a-button>
                  </div>
                );
              }
            }
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    setFieldsDisabled(value) {
      const fields = ["Code", "AppKey"];
      const content = cloneDeep(this.option.form.content);
      const newContent = content.map(item => {
        if (fields.indexOf(item.name) > -1) {
          if (item.props && typeof item.props === "object") {
            item.props.disabled = value;
          } else {
            item.props = {
              disabled: value
            };
          }
        }
        return item;
      });
      this.$refs.dataTable.updateFormContent("", "", newContent);
    },
    edit(Id) {
      this.$refs.dataTable.edit(Id);
    },
    del(Id) {
      this.$refs.dataTable.del({ Id: Id });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped></style>
